import { PartnerStatus, ProductInterest, UseCase } from 'modules/data/domain';

import image2 from './assets/image 2.png';
import image3 from './assets/image 3.png';
import image4 from './assets/image 4.png';
import image8 from './assets/image 8.png';
import image11 from './assets/image 11.png';
import image12 from './assets/image 12.png';
import image15 from './assets/image 15.png';
import image16 from './assets/image 16.png';
import image18 from './assets/image 18.png';
import { messages } from './PreAhaMoment.messages';
import { PreAhaPath, TypeOfGL } from './PreAhaMoment.types';

const xeroPath1 = [
    [
        {
            imageSrc: image8,
            description: messages.description8,
        },
        {
            imageSrc: image15,
            description: messages.description15,
        },
        {
            imageSrc: image16,
            description: messages.description16,
        },
        {
            imageSrc: image2,
            description: messages.description2,
        },
    ],
];

export function getAdditionalScreenItems(typeOfGL: TypeOfGL, path: PreAhaPath) {
    switch (typeOfGL) {
        case TypeOfGL.Xero:
            switch (path) {
                case PreAhaPath.Path1:
                    return xeroPath1;
                case PreAhaPath.Path2:
                    return [
                        [
                            {
                                imageSrc: image12,
                                description: messages.description12,
                            },
                            {
                                imageSrc: image3,
                                description: messages.description3,
                            },
                            {
                                imageSrc: image11,
                                description: messages.description11,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16Path2,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                case PreAhaPath.Path3:
                    return [
                        [
                            {
                                imageSrc: image8,
                                description: messages.description8,
                            },
                            {
                                imageSrc: image15,
                                description: messages.description15,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16,
                            },
                            {
                                imageSrc: image2,
                                description: messages.description2,
                            },
                        ],
                        [
                            {
                                imageSrc: image12,
                                description: messages.description12,
                            },
                            {
                                imageSrc: image3,
                                description: messages.description3,
                            },
                            {
                                imageSrc: image11,
                                description: messages.description11,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                default:
                    return [];
            }

            break;

        case TypeOfGL.QuickBooks:
            switch (path) {
                case PreAhaPath.Path1:
                    return xeroPath1;
                case PreAhaPath.Path2:
                    return [
                        [
                            {
                                imageSrc: image12,
                                description: messages.description12,
                            },
                            {
                                imageSrc: image3,
                                description: messages.description3,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16Path2,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                case PreAhaPath.Path3:
                    return [
                        [
                            {
                                imageSrc: image8,
                                description: messages.description8,
                            },
                            {
                                imageSrc: image15,
                                description: messages.description15,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16,
                            },
                            {
                                imageSrc: image2,
                                description: messages.description2,
                            },
                        ],
                        [
                            {
                                imageSrc: image12,
                                description: messages.description12,
                            },
                            {
                                imageSrc: image3,
                                description: messages.description3,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                default:
                    return [];
            }

            break;

        case TypeOfGL.Cin7:
            switch (path) {
                case PreAhaPath.Path1:
                    return xeroPath1;
                case PreAhaPath.Path2:
                    return [
                        [
                            {
                                imageSrc: image12,
                                description: messages.description12,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16Path2,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                case PreAhaPath.Path3:
                    return [
                        [
                            {
                                imageSrc: image8,
                                description: messages.description8,
                            },
                            {
                                imageSrc: image15,
                                description: messages.description15,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16,
                            },
                            {
                                imageSrc: image2,
                                description: messages.description2,
                            },
                        ],
                        [
                            {
                                imageSrc: image18,
                                description: messages.description18,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                default:
                    return [];
            }

            break;

        case TypeOfGL.NetSuite:
            switch (path) {
                case PreAhaPath.Path1:
                    return xeroPath1;
                case PreAhaPath.Path2:
                    return [
                        [
                            {
                                imageSrc: image12,
                                description: messages.description12,
                            },
                            {
                                imageSrc: image3,
                                description: messages.description3,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16Path2,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                case PreAhaPath.Path3:
                    return [
                        [
                            {
                                imageSrc: image8,
                                description: messages.description8,
                            },
                            {
                                imageSrc: image15,
                                description: messages.description15,
                            },
                            {
                                imageSrc: image16,
                                description: messages.description16,
                            },
                            {
                                imageSrc: image2,
                                description: messages.description2,
                            },
                        ],
                        [
                            {
                                imageSrc: image18,
                                description: messages.description18,
                            },
                            {
                                imageSrc: image3,
                                description: messages.description3,
                            },
                            {
                                imageSrc: image4,
                                description: messages.description4,
                            },
                        ],
                    ];
                default:
                    return [];
            }

            break;

        case TypeOfGL.Other:
            return xeroPath1;

        default:
            return [];
    }
}

export function getGLType(answerAboutGL: PartnerStatus | ProductInterest) {
    if (
        [PartnerStatus.XeroGold, PartnerStatus.XeroOther, PartnerStatus.XeroPlatinum, ProductInterest.Xero].includes(
            answerAboutGL
        )
    ) {
        return TypeOfGL.Xero;
    }

    if (
        [
            PartnerStatus.QBOElite,
            PartnerStatus.QBOOther,
            PartnerStatus.QBOPlatinum,
            ProductInterest.QuickBooksOnline,
        ].includes(answerAboutGL)
    ) {
        return TypeOfGL.QuickBooks;
    }

    if ([PartnerStatus.OracleNetSuite, ProductInterest.OracleNetSuite].includes(answerAboutGL)) {
        return TypeOfGL.NetSuite;
    }

    if ([ProductInterest.Cin7Core].includes(answerAboutGL as ProductInterest)) {
        return TypeOfGL.Cin7;
    }

    return TypeOfGL.Other;
}

export function getPath(useCases: UseCase[]) {
    const usaCesesSet = new Set(useCases);
    const hasAutomateApprovalWorkflows = usaCesesSet.has(UseCase.AutomateApprovalWorkflows);
    const hasSpeedUpApprovalProcess = usaCesesSet.has(UseCase.SpeedupTheApprovalProcess);

    if (useCases.length === 1 && (hasAutomateApprovalWorkflows || hasSpeedUpApprovalProcess)) {
        return PreAhaPath.Path1;
    }

    if (useCases.length === 2 && hasAutomateApprovalWorkflows && hasSpeedUpApprovalProcess) {
        return PreAhaPath.Path1;
    }

    const hasStreamlineAuditProcesses = usaCesesSet.has(UseCase.StreamlineAuditProcesses);
    const hasEstablishInternalFinancialControls = usaCesesSet.has(UseCase.EstablishInternalFinancialControls);

    if (useCases.length === 1 && (hasStreamlineAuditProcesses || hasEstablishInternalFinancialControls)) {
        return PreAhaPath.Path2;
    }

    if (useCases.length === 2 && hasStreamlineAuditProcesses && hasEstablishInternalFinancialControls) {
        return PreAhaPath.Path2;
    }

    return PreAhaPath.Path3;
}
